import type { ShareBlockNames } from '@/features/markets/types';
import { sanitizeName } from '@/shared/lib/format/sanitizeName';

export function getMarketBlockTabParam(blockName: ShareBlockNames, index: number, tabName: string) {
  return `${sanitizeName(blockName)}-${index}%3A${sanitizeName(tabName)}`;
}
